import React from 'react';
import { useIntl } from 'react-intl';
import SearchBar from '../../../../ui/canon/SearchBar.jsx';

export default function ProgramFilters({ filters, onFiltersChange, programCounts, className = '' }) {
  const intl = useIntl();
  const goalOptions = [
    { value: 'grow', label: intl.formatMessage({ id: 'sprints.filters.goal.grow' }) },
    { value: 'exit', label: intl.formatMessage({ id: 'sprints.filters.goal.exit' }) },
    { value: 'protect', label: intl.formatMessage({ id: 'sprints.filters.goal.protect' }) },
  ];
  const levelOptions = [
    { value: 'starter', label: intl.formatMessage({ id: 'sprints.filters.level.starter' }) },
    { value: 'intermediate', label: intl.formatMessage({ id: 'sprints.filters.level.intermediate' }) },
    { value: 'advanced', label: intl.formatMessage({ id: 'sprints.filters.level.advanced' }) },
  ];

  const toggle = (list, value) => (list.includes(value) ? list.filter((v) => v !== value) : [...list, value]);

  return (
    <div className={`space-y-5 ${className}`}>
      <div className="flex flex-col md:flex-row gap-3">
        <div className="flex-1">
          <SearchBar
            value={filters.search}
            onChange={(value) => onFiltersChange({ ...filters, search: value })}
            placeholder={intl.formatMessage({ id: 'sprints.filters.search_placeholder' })}
            variant="outline"
            size="md"
          />
        </div>
        <select
          value={filters.sortBy}
          onChange={(e) => onFiltersChange({ ...filters, sortBy: e.target.value })}
          className="rounded-lg border border-border bg-card px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[var(--succession-focus-ring)]"
        >
          <option value="popular">{intl.formatMessage({ id: 'sprints.filters.sort.most_popular' })}</option>
          <option value="newest">{intl.formatMessage({ id: 'sprints.filters.sort.newest' })}</option>
          <option value="rating">{intl.formatMessage({ id: 'sprints.filters.sort.highest_rated' })}</option>
          <option value="price-low">{intl.formatMessage({ id: 'sprints.filters.sort.price_low' })}</option>
          <option value="price-high">{intl.formatMessage({ id: 'sprints.filters.sort.price_high' })}</option>
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {goalOptions.map((g) => {
          const selected = filters.goals.includes(g.value);
          const count = programCounts?.byGoal?.[g.value] || 0;
          return (
            <button
              key={g.value}
              onClick={() => onFiltersChange({ ...filters, goals: toggle(filters.goals, g.value) })}
              className={`px-4 py-3 rounded-lg border-2 transition-all ${
                selected ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-card hover:border-primary/50 hover:bg-[var(--succession-hover-bg)]'
              } focus:outline-none focus:ring-2 focus:ring-[var(--succession-focus-ring)]`}
            >
              <span className="font-medium">{g.label}</span>
              {programCounts ? <span className="text-xs text-muted-foreground ml-2">({count})</span> : null}
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-2">
        {levelOptions.map((l) => {
          const selected = filters.levels.includes(l.value);
          const count = programCounts?.byLevel?.[l.value] || 0;
          return (
            <button
              key={l.value}
              onClick={() => onFiltersChange({ ...filters, levels: toggle(filters.levels, l.value) })}
              className={`px-3 py-2 rounded-lg border-2 transition-all ${
                selected ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-card hover:border-primary/50 hover:bg-[var(--succession-hover-bg)]'
              } focus:outline-none focus:ring-2 focus:ring-[var(--succession-focus-ring)]`}
            >
              <span className="font-medium">{l.label}</span>
              {programCounts ? <span className="text-xs text-muted-foreground ml-2">({count})</span> : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}


